import { render } from "./MailTop.vue?vue&type=template&id=49bc1c80&scoped=true"
import script from "./MailTop.vue?vue&type=script&setup=true&lang=js"
export * from "./MailTop.vue?vue&type=script&setup=true&lang=js"

import "./MailTop.vue?vue&type=style&index=0&id=49bc1c80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bc1c80"],['__file',"src/views/mail/MailTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49bc1c80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49bc1c80', __exports__)) {
    api.reload('49bc1c80', __exports__)
  }
  
  module.hot.accept("./MailTop.vue?vue&type=template&id=49bc1c80&scoped=true", () => {
    api.rerender('49bc1c80', render)
  })

}


export default __exports__